import { render } from "./loginCode.vue?vue&type=template&id=c8e72c1e&scoped=true"
import script from "./loginCode.vue?vue&type=script&lang=js"
export * from "./loginCode.vue?vue&type=script&lang=js"

import "./loginCode.vue?vue&type=style&index=0&id=c8e72c1e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8e72c1e"]])

export default __exports__